import type { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useQuery } from '@edreamsodigeo/frontend-api-client';

import {
  FeeSelected,
  GetFlightSummarySelectedTotalPriceQuery,
  GetFlightSummarySelectedTotalPriceQueryVariables,
} from 'generated/graphql';
import { FLIGHT_SUMMARY_SELECTED_TOTAL_PRICE } from 'clientState/providers/operations/flightSummarySelectedTotalPrice';

export const useFlightSummarySelectedTotalPrice = (
  flightSelectionData
): UseQueryResult<
  GetFlightSummarySelectedTotalPriceQuery,
  GetFlightSummarySelectedTotalPriceQueryVariables
> => {
  const {
    fareItineraryKey = '',
    priceWithoutDiscountSelected,
    searchId = '',
    segmentKeys = [],
  } = flightSelectionData?.data || {};
  const feeSelected = priceWithoutDiscountSelected
    ? FeeSelected.FullPrice
    : FeeSelected.PrimePrice;
  const isMeta = false;
  return useQuery<
    GetFlightSummarySelectedTotalPriceQuery,
    GetFlightSummarySelectedTotalPriceQueryVariables
  >(FLIGHT_SUMMARY_SELECTED_TOTAL_PRICE, {
    variables: {
      request: {
        fareItineraryKey: fareItineraryKey.split('_')[0],
        feeSelected,
        searchId: String(searchId),
        segmentKeys,
        isMeta,
      },
    },
  });
};
